import {attributesTableLoader} from '../../../../util/dataLoader';
import {withTimeout} from '../../../../util/http/withTimeout';
import {IAttributesTableAPIResponse} from './attributesTableComponentSlice';

export function getAttributesTable(filters): Promise<IAttributesTableAPIResponse> {
  const controller = new AbortController();
  return withTimeout(
    attributesTableLoader.get(filters, controller) as Promise<IAttributesTableAPIResponse>,
    controller
  );
}
